import React from 'react';
import {Link} from "react-router-dom";
import * as yup from "yup";
import { FieldTableColumnProps } from 'components/FieldTable/FieldTableTypes';
import {
    Distributor,
    DistributorsQueryDocument,
    useUpdateDistributorsMutationMutation
} from '../../generated/graphql';
import {SideList} from "../../components/SideList";

/*
const schema =  yup.object().shape({
  name: yup.string().min(1),
  email: yup.string().email().required()
});
*/

const columns:FieldTableColumnProps<Distributor>[] = [
  {
    accessor:'name',
    header: 'Name',
    dataType:'link',
    options: {
      getLink:({row})=> {
        return ({
          pathname: '/database/distributors/' + row.id,
          search: (location.search ? location.search : '')
        });
      }
    }
  },
  {
    accessor:'email',
    header:'Email',
    dataType:'default',
    width:'narrow'
  }
];


const Distributors = ()=> {
  const updateMutation = useUpdateDistributorsMutationMutation();
    return <SideList
        searchForm={null}
        query={DistributorsQueryDocument}
        baseUrl="/database/distributors/" label="Distributors"
        className="distributors"
        permission="distributors"
        deleteMutation={updateMutation}
        columns={columns}/>;
}
export default Distributors;
